import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

var QuoteSize;
(function (QuoteSize) {
    QuoteSize["BIG"] = "big";
    QuoteSize["SMALL"] = "small";
})(QuoteSize || (QuoteSize = {}));
var QuoteLayout;
(function (QuoteLayout) {
    QuoteLayout["WITH_IMAGE"] = "with-image";
    QuoteLayout["NORMAL"] = "normal";
})(QuoteLayout || (QuoteLayout = {}));

const rocheQuoteCss = ":host{display:block;margin-top:3rem;width:100%}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .quote__container--with-image{width:100%}@media (min-width: 48rem){:host .quote__container--with-image{display:grid;grid-template-columns:calc(((5 * 100%) / 12) - calc(24px / 2)) 50%;gap:calc(8.3333333333% + 24px)}}@media (min-width: 48rem){:host .quote__container--equal-ratio{grid-template-columns:calc(50% - calc(24px / 2)) calc(50% - calc(24px / 2));gap:24px}}@media (min-width: 90rem){:host .quote__container--equal-ratio{grid-template-columns:calc(50% - calc(32px / 2)) calc(50% - calc(32px / 2));gap:32px}}:host .quote__content{margin:auto}:host .quote__image{width:100%}@media (min-width: 48rem){:host .quote__image{margin:auto}}:host .quote__text{font-family:\"roche-serif\";font-style:normal;font-weight:200;font-size:2rem;line-height:2.875rem;margin-top:2.5rem}@media (min-width: 48rem){:host .quote__text{font-size:2.5rem;line-height:3.5rem}}@media (min-width: 90rem){:host .quote__text{font-size:3rem;line-height:4.1875rem}}@media (min-width: 48rem){:host .quote__text{margin:0}}:host .quote__text--small{font-family:\"roche-serif\";font-style:normal;font-weight:200;font-size:1.5rem;line-height:2.125rem}@media (min-width: 48rem){:host .quote__text--small{font-size:1.75rem;line-height:2.5rem}}@media (min-width: 90rem){:host .quote__text--small{font-size:1.875rem;line-height:2.5rem}}:host ::slotted([slot=subline]){margin-top:1rem}@media (min-width: 48rem){:host ::slotted([slot=subline]){margin-top:1.5rem}}@media (min-width: 90rem){:host ::slotted([slot=subline]){margin-top:2rem}}:host ::slotted([slot=image]){margin:auto}:host ::slotted([slot=link]){margin:2rem 0 0 0}";
const RocheQuoteStyle0 = rocheQuoteCss;

const RocheQuote$1 = /*@__PURE__*/ proxyCustomElement(class RocheQuote extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.quote = undefined;
        this.size = QuoteSize.BIG;
        this.layout = QuoteLayout.NORMAL;
        this.isEqualRatio = false;
    }
    render() {
        const isQuoteWithImage = (this.layout === QuoteLayout.WITH_IMAGE);
        const quoteSizeIsSmall = (this.size === QuoteSize.SMALL);
        const quoteContainerClasses = {
            quote__container: true,
            'quote__container--with-image': isQuoteWithImage,
            'quote__container--equal-ratio': isQuoteWithImage && this.isEqualRatio,
        };
        const quoteTextClasses = {
            quote__text: true,
            'quote__text--small': quoteSizeIsSmall,
        };
        return (h(Host, { key: 'c3e92731d1489b5f91c205c6b4976d7fab06fca1' }, h("div", { key: '4ea8d3df317c5d1273085af57a7623fde32865e4', part: "quote-container", class: quoteContainerClasses }, isQuoteWithImage
            && h("div", { class: "quote__image" }, h("slot", { name: "image" })), h("div", { key: '7b0d71d49b774f85ff546ce0c36b2dffb58a1b60', class: "quote__content" }, h("div", { key: 'e7daefd7d1bda0d33b1b367f57ac707ca7c31499', class: quoteTextClasses }, this.quote), h("slot", { key: 'eacabf3378276577cd08f732421a17f7e5f1cfdc', name: "subline" }), isQuoteWithImage && h("slot", { name: "link" })))));
    }
    static get style() { return RocheQuoteStyle0; }
}, [1, "roche-quote", {
        "quote": [1],
        "size": [1],
        "layout": [1],
        "isEqualRatio": [4, "is-equal-ratio"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-quote"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-quote":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheQuote$1);
            }
            break;
    } });
}

const RocheQuote = RocheQuote$1;
const defineCustomElement = defineCustomElement$1;

export { RocheQuote, defineCustomElement };

//# sourceMappingURL=roche-quote.js.map